import { SittingSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { AlertBanner } from "@/components/we360/AlertBanner";
import { SITTING_OPTIONS, getSittingCategory } from "./helpers";

export default function Step5Results({
  tiempoSentado,
  onTiempoSentadoChange,
  metVig,
  metMod,
  metWalk,
  ipaqClass,
  sittingCat,
  errors,
}) {
  const showSedAlert = sittingCat && (sittingCat.key === "high" || sittingCat.key === "very_high");

  return (
    <div>
      <SittingSVG />

      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        En un día típico de lunes a viernes, ¿cuántas horas pasas sentado/a? Incluye trabajo,
        clases, celular, TV y traslados. <strong>No cuentes las horas de sueño.</strong>
      </div>

      <PillSelect
        label="Horas sentado/a en día típico"
        options={SITTING_OPTIONS.map((o) => ({ label: o.label, value: o.value }))}
        value={tiempoSentado}
        onChange={onTiempoSentadoChange}
        error={errors?.getError("tiempoSentado")}
        testId="f3-sitting"
        columns={1}
      />

      {sittingCat && (
        <CalculatedBadge
          label="Índice de sedentarismo"
          value={sittingCat.category}
          categoryColor={sittingCat.color}
          testId="badge-sedentarismo"
        />
      )}

      {/* Global results section */}
      {ipaqClass && (
        <div className="mt-5 pt-4" style={{ borderTop: "1px solid #E2D9CB" }}>
          <p className="text-xs font-bold mb-3 uppercase tracking-wide" style={{ color: "#71644C" }}>
            Resultados globales
          </p>

          {metVig !== null && metVig !== undefined && (
            <CalculatedBadge label="MET vigorosa" value={metVig || 0} unit="MET-min/sem" testId="result-met-vig" />
          )}
          {metMod !== null && metMod !== undefined && (
            <CalculatedBadge label="MET moderada" value={metMod || 0} unit="MET-min/sem" testId="result-met-mod" />
          )}
          {metWalk !== null && metWalk !== undefined && (
            <CalculatedBadge label="MET caminata" value={metWalk || 0} unit="MET-min/sem" testId="result-met-walk" />
          )}

          <div className="my-3" />

          <CalculatedBadge
            label="MET total / semana"
            value={ipaqClass.metTotal}
            unit="MET-min/sem"
            category={ipaqClass.label}
            categoryColor={ipaqClass.color}
            testId="badge-met-total"
          />

          {/* OMS Recommendations */}
          {ipaqClass.key === "low" && (
            <AlertBanner variant="danger" testId="alert-oms-low">
              La OMS recomienda al menos 150 minutos de actividad moderada o 75 minutos de
              vigorosa por semana (aprox. 600 MET-min).
            </AlertBanner>
          )}
          {ipaqClass.key === "moderate" && (
            <AlertBanner variant="info" testId="alert-oms-moderate">
              ¡Buen nivel! Cumples la recomendación mínima de la OMS. Para mayores beneficios,
              apunta a 300 min moderada o 150 min vigorosa por semana.
            </AlertBanner>
          )}
          {ipaqClass.key === "high" && (
            <AlertBanner variant="success" testId="alert-oms-high">
              ¡Excelente! Tu nivel de actividad física supera las recomendaciones de la OMS.
            </AlertBanner>
          )}

          {showSedAlert && (
            <div className="mt-2">
              <AlertBanner variant="warning" testId="alert-sedentarismo">
                Aunque tengas un buen nivel de actividad física, pasar muchas horas sentado/a
                es un factor de riesgo independiente. Intenta hacer pausas activas cada hora.
              </AlertBanner>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
